import { useQuery } from '@tanstack/react-query';
import { ChatPartnerApi } from 'api/ApiHelper';
import { chatQueryKey } from 'queries/chat/queryKey';

export const useGetChannelByContentIdQuery = (contentId: number, enabled = false) =>
  useQuery({
    queryKey: chatQueryKey.partnerChatByContent(contentId),
    queryFn: () => ChatPartnerApi.getChannelByContentId(contentId),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 50,
    refetchInterval: 1000 * 60 * 30,
    enabled,
  });
